import React, { useId } from "react";

interface BrandMarkProps {
  // Crescent and dome only, without "24/7", for tight spaces.
  compact?: boolean;
  className?: string;
}

// The Masjid 24/7 mark. The crescent and numbers take the text colour, so it reads on dark and light.
const BrandMark: React.FC<BrandMarkProps> = ({ compact, className }) => {
  // An id per mark: a gradient shared by id stops drawing when its first copy is hidden.
  const gradient = `m247-dome-${useId().replace(/[^a-zA-Z0-9_-]/g, "")}`;
  const width = compact ? 120 : 278;

  return (
    <svg
      className={className}
      viewBox={`0 0 ${width} 136`}
      style={{ aspectRatio: `${width} / 136` }}
      role="img"
      aria-label="Masjid 24/7"
    >
      <defs>
        <linearGradient id={gradient} x1="118.96" y1="95.6" x2="0" y2="95.6" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1B2B69" />
          <stop offset="0.1" stopColor="#3B479D" />
          <stop offset="0.19" stopColor="#4E58B1" />
          <stop offset="0.27" stopColor="#6C6DC9" />
          <stop offset="0.36" stopColor="#9185D7" />
          <stop offset="0.61" stopColor="#E2B3E1" />
          <stop offset="0.69" stopColor="#FBCCDC" />
          <stop offset="0.81" stopColor="#FFD4CD" />
          <stop offset="0.88" stopColor="#FFC4A8" />
          <stop offset="0.95" stopColor="#FFB48C" />
        </linearGradient>
      </defs>
      <path
        fill={`url(#${gradient})`}
        d="M1.3 133.21C1.3 133.21 1.3 133.14 1.31 133.1C1.46 131.41 1.7 129.72 2.04 128.06C9.36 92.77 54.05 76.64 59.48 74.8C64.92 76.64 109.61 92.77 116.93 128.06C117.27 129.75 117.51 131.46 117.66 133.18C117.66 133.19 117.66 133.2 117.66 133.21C119.27 126.18 119.38 118.9 117.96 111.83C111.13 78.9 71.87 62.56 61.56 58.68L59.46 57.98L57.38 58.68C47.07 62.56 7.81 78.9 0.97 111.83C-0.44 118.9 -0.33 126.19 1.28 133.21H1.3Z"
      />
      <path
        fill="currentColor"
        d="M79.91 28.51C80.75 28.09 81.54 27.64 82.3 27.14C82.55 26.98 82.87 26.93 83.18 27.02C83.72 27.19 84.02 27.77 83.85 28.31C82.69 31.93 80.7 35.26 78.04 38.01C75.47 40.66 72.26 42.77 68.55 44.08C62.12 46.35 55.38 45.79 49.68 43.07C43.98 40.34 39.32 35.44 37.05 29.01C35.15 23.61 35.23 17.99 36.93 12.95C38.66 7.8 42.07 3.26 46.75 0.18C47 0.02 47.32 -0.03 47.63 0.06C48.17 0.23 48.47 0.81 48.3 1.35C47.56 3.66 47.19 6.1 47.22 8.58C47.26 10.96 47.67 13.39 48.52 15.78C50.6 21.67 54.87 26.17 60.09 28.67C65.31 31.17 71.49 31.68 77.39 29.6C78.27 29.29 79.13 28.93 79.94 28.52L79.91 28.51Z"
      />
      {!compact && (
        <path
          fill="currentColor"
          d="M189.93 63.83L177.75 77.62L176.65 78.86H137.2V65.74C148.39 61.57 161.25 55.81 169.44 51.96C177.29 48.04 179.46 44.95 179.46 40.6C179.46 36.51 175.95 33.59 169.61 33.59C162.93 33.59 158.75 36.43 158.75 42.36C158.75 42.78 158.75 43.28 158.83 44.19L137.53 42.36C137.45 41.44 137.36 40.69 137.36 39.69C137.36 26.33 151.73 19.14 170.18 19.14C188.63 19.14 201.59 24.91 201.59 38.69C201.59 46.87 197.99 51.38 189.14 55.97C183.29 59.15 175.19 61.74 167.08 63.82H189.91L189.93 63.83ZM237.63 77.64V91.17C225.35 101.53 217.33 114.14 217.33 132.51V135.68H197.37V134.34C197.37 118.14 205.48 103.11 220.17 91.92H201.79L213.4 77.63H237.64L237.63 77.64ZM263.09 57.49V21.56H234.75L197.43 63.83L184.15 78.86L181.96 81.35V92.52H194.08L194.56 91.93L206.3 78L211.55 71.65L223.37 58.19L227.75 53.05C229.1 51.46 230.44 49.86 231.77 48.26L244.34 33.42V58.2H230.97L225.91 64.21L219.5 71.57H243.77V91.66H263.11V71.57H277.07V57.5H263.1L263.09 57.49Z"
        />
      )}
    </svg>
  );
};

export default BrandMark;
